import { TableCell, TableRow } from "@mui/material"

export function Message({ item: { time, message } }) {
    return (
        <TableRow>
            <TableCell>{time.format("{HH}:{mm}:{ss}")}</TableCell>
            <TableCell>{message}</TableCell>
        </TableRow>
    )
}
